import { Capacitor } from "@capacitor/core";

export type Platform = "ios" | "android" | "web";

/**
 * Module-load snapshot of `Capacitor.isNativePlatform()`. True inside a real
 * native shell (iOS or Android), false in browsers and tests.
 *
 * Test note: this is a const, not a function. To override in tests use:
 *   `vi.mock("@/lib/capacitor", async (orig) => ({ ...(await orig()), isNative: true }))`
 */
export const isNative: boolean = Capacitor.isNativePlatform();

/** Module-load snapshot of `Capacitor.getPlatform()`. */
export const platform: Platform = Capacitor.getPlatform() as Platform;

export const isIOS = platform === "ios";
export const isAndroid = platform === "android";

export { Capacitor };
